import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CropsGridComponent} from './crops-grid.component';
import {DxDataGridModule, DxTreeListModule, DxTextAreaModule} from 'devextreme-angular';
import {GridDefaultModule, GridTitleModule, TreeListDefaultModule, TreeListTitleModule} from 'shared';
import {CropSelectorModule} from '../crop-selector/crop-selector.module';
import {TabModule} from '../../tab/tab.module';


@NgModule({
  declarations: [CropsGridComponent],
  imports: [
    CommonModule,
    DxDataGridModule,
    GridDefaultModule,
    GridTitleModule,
    DxTreeListModule,
    CropSelectorModule,
    TabModule,
    TreeListTitleModule,
    TreeListDefaultModule, DxTextAreaModule,
  ],
  exports: [CropsGridComponent]
})
export class CropsGridModule {
}
